import _extends from '@babel/runtime/helpers/esm/extends';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { HStack, Center, Box } from '@chakra-ui/react';
import { Card } from '@outdoorly/card';
import NextImage from 'next/image';
import { HelpCircleIcon } from '@outdoorly/icons';
import { getImageLoader } from '@outdoorly/util';

var _excluded = ["children", "src", "size", "isDisabled", "wrapperProps"];
/**
 * Used for displaying products in a list.
 *
 * TODO: Support srcSet prop
 */
var ProductSummaryContainer = function ProductSummaryContainer(_ref) {
  var children = _ref.children,
    src = _ref.src,
    size = _ref.size,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    wrapperProps = _ref.wrapperProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = _objectSpread({}, isDisabled && {
    opacity: 0.5,
    pointerEvents: 'none'
  });
  return /*#__PURE__*/React.createElement(HStack, _extends({
    spacing: 4
  }, wrapperProps, styles), /*#__PURE__*/React.createElement(Card, _extends({
    bg: "gray.75",
    minWidth: size,
    boxSize: size,
    padding: 0,
    overflow: "hidden",
    position: "relative",
    borderWidth: 1,
    borderColor: "scheme.border"
  }, props), src ? /*#__PURE__*/React.createElement(NextImage, {
    loader: getImageLoader(src),
    src: src,
    layout: "fill",
    objectFit: "contain",
    objectPosition: "center",
    alt: "Product thumbnail",
    className: "darken"
  }) : /*#__PURE__*/React.createElement(Center, {
    height: "full"
  }, /*#__PURE__*/React.createElement(HelpCircleIcon, {
    height: 6,
    width: 6,
    color: "scheme.black"
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: styles,
    flexGrow: 1
  }, children));
};

export { ProductSummaryContainer };
